window.Cozique = window.Cozique || {};

window.Cozique.formatMoney = function formatMoney(cents, format) {
  const value = Number(cents) || 0;
  const withDelimiters = (number, precision, thousands = ',', decimal = '.') => {
    const parts = (number / 100).toFixed(precision).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts.join(decimal) : parts[0];
  };
  const fmt = format || '${{amount}}';
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
    switch (key) {
      case 'amount_no_decimals':
        return withDelimiters(value, 0);
      case 'amount_with_comma_separator':
        return withDelimiters(value, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return withDelimiters(value, 0, '.', ',');
      case 'amount_with_apostrophe_separator':
        return withDelimiters(value, 2, "'", '.');
      default:
        return withDelimiters(value, 2);
    }
  });
};

if (!customElements.get('bundle-tiers')) {
  class BundleTiers extends HTMLElement {
    connectedCallback() {
      this.price = parseInt(this.dataset.price, 10) || 0;
      this.available = true;
      this.quantityInput = this.querySelector('[data-bundle-quantity]');
      this.inputs = [...this.querySelectorAll('.bundle-tiers__input')];
      this.inputs.forEach((input) => input.addEventListener('change', () => this.update()));

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event && event.data && event.data.variant;
          if (!variant) return;
          this.price = variant.price;
          this.available = variant.available;
          // Dawn resets the button text after a variant change, so re-apply ours afterwards.
          setTimeout(() => this.update());
        });
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    get selected() {
      return this.inputs.find((input) => input.checked) || this.inputs[0];
    }

    totalFor(input) {
      const quantity = parseInt(input.value, 10) || 1;
      const discount = parseInt(input.dataset.discount, 10) || 0;
      const compare = this.price * quantity;
      return { quantity, compare, total: Math.round((compare * (100 - discount)) / 100) };
    }

    update() {
      const format = this.dataset.moneyFormat;
      const money = (cents) => window.Cozique.formatMoney(cents, format);

      this.inputs.forEach((input) => {
        const tier = input.closest('.bundle-tiers__tier');
        const { compare, total } = this.totalFor(input);
        tier.classList.toggle('is-selected', input.checked);
        const totalEl = tier.querySelector('[data-bundle-total]');
        const compareEl = tier.querySelector('[data-bundle-compare]');
        if (totalEl) totalEl.textContent = money(total);
        if (compareEl) compareEl.textContent = money(compare);
      });

      const selected = this.selected;
      if (!selected) return;
      const { quantity, total } = this.totalFor(selected);
      this.currentTotal = total;
      if (this.quantityInput) this.quantityInput.value = quantity;

      const button = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      const label = button && button.querySelector('span');
      if (label && this.available && !button.disabled && this.dataset.label) {
        label.textContent = this.dataset.label.replace('[quantity]', quantity).replace('[price]', money(total));
      }

      document.querySelectorAll('[data-sticky-price]').forEach((el) => (el.textContent = money(total)));
      document.dispatchEvent(new CustomEvent('cozique:bundle-change', { detail: { total, quantity } }));
    }
  }

  customElements.define('bundle-tiers', BundleTiers);
}

if (!customElements.get('shipping-progress')) {
  class ShippingProgress extends HTMLElement {
    connectedCallback() {
      this.onChange = (event) => this.render(event.detail.total);
      document.addEventListener('cozique:bundle-change', this.onChange);
      const bundle = document.querySelector('bundle-tiers');
      if (bundle && typeof bundle.currentTotal === 'number') this.render(bundle.currentTotal);
    }

    disconnectedCallback() {
      document.removeEventListener('cozique:bundle-change', this.onChange);
    }

    render(pendingTotal) {
      const threshold = parseInt(this.dataset.threshold, 10) || 0;
      const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
      if (!threshold) return;
      const total = cartTotal + pendingTotal;
      const remaining = threshold - total;
      const text = this.querySelector('[data-shipping-text]');
      const fill = this.querySelector('[data-shipping-fill]');
      if (fill) fill.style.width = `${Math.min(100, Math.round((total / threshold) * 100))}%`;
      if (!text) return;
      if (remaining > 0) {
        const amount = window.Cozique.formatMoney(remaining, this.dataset.moneyFormat);
        const [before, after = ''] = this.dataset.textRemaining.split('[amount]');
        text.textContent = '';
        const strong = document.createElement('strong');
        strong.textContent = amount;
        text.append(before, strong, after);
      } else {
        text.textContent = this.dataset.textUnlocked;
      }
      this.classList.toggle('is-unlocked', remaining <= 0);
    }
  }

  customElements.define('shipping-progress', ShippingProgress);
}

if (!customElements.get('gallery-dots')) {
  class GalleryDots extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('media-gallery').then(() => this.init());
    }

    init() {
      if (this.childElementCount) return;
      this.gallery = this.closest('media-gallery');
      if (!this.gallery || !this.gallery.elements || !this.gallery.elements.viewer) return;
      this.viewer = this.gallery.elements.viewer;
      this.items = [...this.viewer.querySelectorAll('li[data-media-id]')].filter(
        (item) => !item.classList.contains('product__media-item--variant')
      );
      if (this.items.length < 2) return;

      this.items.forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gallery-dots__dot';
        dot.setAttribute('aria-label', `${this.dataset.label || 'Show image'} ${index + 1}`);
        dot.addEventListener('click', () => {
          this.gallery.setActiveMedia(item.dataset.mediaId, false);
          this.setActive(item.dataset.mediaId);
        });
        this.append(dot);
      });

      this.viewer.addEventListener('slideChanged', (event) => {
        const current = event.detail && event.detail.currentElement;
        if (current) this.setActive(current.dataset.mediaId);
      });

      const active = this.viewer.querySelector('li[data-media-id].is-active') || this.items[0];
      this.setActive(active.dataset.mediaId);
    }

    setActive(mediaId) {
      [...this.children].forEach((dot, index) => {
        const isActive = this.items[index] && this.items[index].dataset.mediaId === mediaId;
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  customElements.define('gallery-dots', GalleryDots);
}

if (!customElements.get('inquiry-form')) {
  class InquiryForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.price = parseInt(this.dataset.price, 10) || 0;
      this.quantity = 1;
      this.total = this.price;

      const bundle = document.querySelector('bundle-tiers');
      if (bundle && typeof bundle.currentTotal === 'number') {
        const selected = bundle.selected;
        this.quantity = selected ? parseInt(selected.value, 10) || 1 : 1;
        this.total = bundle.currentTotal;
      }

      this.onBundle = (event) => {
        this.quantity = event.detail.quantity || this.quantity;
        this.total = event.detail.total;
        this.render();
      };
      document.addEventListener('cozique:bundle-change', this.onBundle);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event && event.data && event.data.variant;
          const field = this.querySelector('[data-inquiry-variant]');
          if (variant && field) field.value = variant.title;
        });
      }

      if (this.form) {
        this.form.noValidate = true;
        this.form.addEventListener('submit', (event) => this.validate(event));
        this.querySelectorAll('input[inputmode="numeric"]').forEach((input) =>
          input.addEventListener('input', () => (input.value = input.value.replace(/\D/g, '')))
        );
      }

      if (/[?&]contact_posted=true/.test(window.location.search) || this.querySelector('.inquiry__errors')) {
        this.scrollIntoView({ block: 'center' });
      }

      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('cozique:bundle-change', this.onBundle);
      if (this.unsubscribe) this.unsubscribe();
    }

    render() {
      const money = window.Cozique.formatMoney(this.total, this.dataset.moneyFormat);
      const summary = this.querySelector('[data-inquiry-summary]');
      const totalEl = this.querySelector('[data-inquiry-total]');
      const quantityField = this.querySelector('[data-inquiry-quantity]');
      const totalField = this.querySelector('[data-inquiry-total-field]');
      const submit = this.querySelector('[data-inquiry-submit]');
      if (summary) summary.textContent = `${this.quantity} × ${this.dataset.product}`;
      if (totalEl) totalEl.textContent = money;
      if (quantityField) quantityField.value = `Buy ${this.quantity}`;
      if (totalField) totalField.value = money;
      if (submit && this.dataset.buttonLabel) submit.textContent = this.dataset.buttonLabel.replace('[price]', money);
    }

    validate(event) {
      let firstInvalid = null;
      this.querySelectorAll('[data-required]').forEach((field) => {
        const control = field.querySelector('input, select, textarea');
        if (!control) return;
        let invalid = false;
        if (field.hasAttribute('data-checkbox')) {
          invalid = !control.checked;
        } else {
          const value = control.value.trim();
          invalid = !value || (field.dataset.pattern && !new RegExp(field.dataset.pattern).test(value));
        }
        field.classList.toggle('is-invalid', invalid);
        control.setAttribute('aria-invalid', invalid ? 'true' : 'false');
        if (invalid && !firstInvalid) firstInvalid = control;
      });
      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.focus();
      }
    }
  }

  customElements.define('inquiry-form', InquiryForm);
}

if (!customElements.get('description-toggle')) {
  class DescriptionToggle extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-description-text]');
      this.button = this.querySelector('button');
      if (!this.text || !this.button) return;
      this.button.addEventListener('click', () => this.toggle());
      this.check = () => {
        if (!this.text.classList.contains('is-collapsed')) return;
        // Only offer "Read more" when the text is actually cut off.
        this.button.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
      };
      this.check();
      window.addEventListener('resize', this.check);
      if (document.fonts) document.fonts.ready.then(this.check);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.check);
    }

    toggle() {
      const expanded = this.text.classList.toggle('is-collapsed') === false;
      this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      this.button.textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
    }
  }

  customElements.define('description-toggle', DescriptionToggle);
}

if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      if (!this.tabs.length) {
        this.hidden = true;
        return;
      }
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = (index + step + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        });
      });
      this.select(0);
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
    }
  }

  customElements.define('product-tabs', ProductTabs);
}
